export default __webpack_public_path__ + "static/media/OSMOS_CALCE-RIBBED_60X120_04.90468d59.jpg";